import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DentalData, MedicalData, MyCpgPodsSettings, MyCpgPodsTypes, PodContent } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';


interface Props {
	settings: MyCpgPodsSettings;
}
export function HealthPlanPod(props: Props) {

	const { settings } = props;
	const medicalData = useSelector<TcsmStates, MedicalData>(state => state?.mycpgPodsState?.pods?.medical_data);
	const dentalData = useSelector<TcsmStates, DentalData>(state => state?.mycpgPodsState?.pods?.dental_data);
	const hidePod = medicalData?.show_pod === YesNoIndicators.No && dentalData?.show_pod === YesNoIndicators.No;
	const hasMedicalPlan = medicalData?.content === PodContent.CONTENT;
	const hasDentalPlan = dentalData?.content === PodContent.CONTENT;
	const routeMatch = useRouteMatch();


	if (hidePod) {
		return null;
	}

	const renderDental = () => {
		if (hasDentalPlan) {
			return (
				<>
					<p className='h3-styled'>{dentalData?.data?.description}</p>
					<p className='grey-caption'>{settings?.dentalLabel}</p>
				</>);


		}

		return <div dangerouslySetInnerHTML={{ __html: settings?.noDentalText }} />;
	};

	const renderMedical = () => {
		if (hasMedicalPlan) {
			return (
				<>
					<p className='h3-styled'>{medicalData?.data?.description}</p>
					<p className='grey-caption'>{settings?.medicalLabel}</p>
				</>);
		}

		return <div dangerouslySetInnerHTML={{ __html: settings?.noMedicalText }} />;
	};


	return (
		<PodGridItem>
			<PodGridItemHeader title={settings?.healthPlanTitle}>
				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.HEALTH}`}>{(!hasMedicalPlan && !hasDentalPlan) ? settings?.learnMoreText : settings?.seeMoreLinkText}</Link>
			</PodGridItemHeader>
			<PodGridContent>
				<PodGridContentItem>
					{renderMedical()}
				</PodGridContentItem>
				<PodGridContentItem>
					{renderDental()}
				</PodGridContentItem>
			</PodGridContent>
		</PodGridItem>
	);

}

